import * as yup from 'yup';

import {publicationConstants} from '../';
import {SCHEMA_DISTRIBUTIONS} from '../Distribution/DistributionsForm/distributionsFormConstants';


export const PUBLICATION_NAME_LENGTH_MAX = 50;
export const PUBLICATION_NAME_LENGTH_MIN = 2;


export const SCHEMA_PUBLICATION_NAME = yup.string()
    .nullable()
    .max(PUBLICATION_NAME_LENGTH_MAX)
    .min(PUBLICATION_NAME_LENGTH_MIN)
    .strictText();


export const SCHEMA_PUBLICATION_TYPE = yup.string()
    .nullable()
    .oneOf(publicationConstants.PUBLICATION_TYPES);


export const SCHEMA_FORM_PUBLICATION = yup.object({
    distributions: SCHEMA_DISTRIBUTIONS.required(),
    name: SCHEMA_PUBLICATION_NAME.required(),
    type: SCHEMA_PUBLICATION_TYPE.required()
});
